<div class="flex h-full flex-col">
  @if (screenServiceLoaded()) {
    <lib-perio-exam-header
      class="z-50 mt-4"
      [isValid]="oneToothTouched()"
      [examFormWidth]="437"
      [isEditing]="isEditing()"
      (cancelExam)="onCancelExam()"
      (resetExam)="onResetExam()"
      (done)="onExamCompleted()"
    >
    </lib-perio-exam-header>
    <div class="mb-4 flex h-full w-full pt-16">
      @if (isReviewActive) {
        <div @previewSlide class="w- absolute top-0 z-40 h-full w-full bg-background-white px-20 pb-10 pt-40">
          <lib-perio-exam-review class="h-full" [teeth]="currentPerioExamTeeth()" />
        </div>
      }

      @if (dialogClosed()) {
        <div class="flex min-w-0 flex-1 justify-end overflow-hidden pt-3">
          @if (!isFirstTooth() && currentPerioExamTeeth() && !isReviewActive) {
            @for (prevTooth of previousPerioExamTooth() ? [previousPerioExamTooth()] : []; track prevTooth!.jaw + '-' + currentSide()) {
              <lib-perio-jaw
                [teeth]="currentPerioExamTeeth()"
                [missingTeeth]="allMissingTeethPositions()"
                [selectedTooth]="prevTooth"
                [activeSide]="currentSide()"
                [activeJaw]="prevTooth?.jaw ?? 'upper'"
                [showRulerLabels]="true"
                [showSideLabels]="true"
                [isLeftSide]="true"
                [isFirstTooth]="false"
                [@jawTransitionExit]="jawAnimationPhase() === 'exit' ? jawAnimationDirection() : null"
                [@jawTransitionEnter]="jawAnimationPhase() === 'enter' ? jawAnimationDirection() : null"
              />
            }
          }
        </div>
        @if (currentTooth(); as tooth) {
          <div class="relative">
            <div class="absolute right-[100%] top-0 z-50 -mt-26 mr-3 h-full min-w-[488px]">
              <lib-perio-exam-toolbar
                class="absolute z-10 flex"
                [isReviewActive]="isReviewActive"
                (reviewClick)="onReviewClick()"
                (voiceToggle)="onVoiceToggle()"
                (selectDevice)="onSelectDevice($event)"
                (toothNavigate)="onToothNavigate($event)"
                [toothList]="tooltipSurfaceList()"
                [isVoiceActive]="voiceStatus() === 'running'"
                [isVoiceLoading]="voiceStatus() === 'starting'"
                [volumeLevel]="volumeLevel()"
                [profileId]="profileId()"
              />
              @if (!isReviewActive) {
                @if (isFirstToothInExam() && !oneToothTouched()) {
                  <div @examIntroSlide class="mt-24 flex h-full max-h-[582px] w-full max-w-[480px] items-center justify-center">
                    <lib-perio-exam-intro />
                  </div>
                } @else if (allTeethTouched() && isLastToothInExam() && currentPerioExamTeeth()) {
                  <div @examIntroSlide class="mt-24 flex h-full max-h-[582px] w-full max-w-[480px] items-center justify-center">
                    <lib-perio-done @doneSlide />
                  </div>
                }
              }
            </div>
          </div>
          @if (!isReviewActive) {
            <ffd-perio-active-tooth-form
              class="-mb-10 max-h-[43rem] flex-shrink-0 -translate-y-26 transition-all duration-300"
              [ngClass]="{
                'w-[437px]': !cheatSheetOpened(),
                'w-[681px]': cheatSheetOpened()
              }"
              [tooth]="tooth"
              [teeth]="currentPerioExamTeeth()"
              [activeJaw]="jawConfig().jaw"
              [currentSide]="currentSide()"
              [isFirstTooth]="isFirstTooth()"
              [isLastTooth]="isLastTooth()"
              [isCentralRecession]="isCentralRecession()"
              [cheatSheetOpened]="cheatSheetOpened()"
              [isAiThinking]="isAiThinking()"
              [shouldSlowDown]="shouldSlowDown()"
              [visualDirection]="jawConfig().visualDirection"
              [nextTooth]="nextPerioExamTooth()"
              [previousTooth]="previousPerioExamTooth()"
              (toothSidePerioDone)="onToothSidePerioDone($event)"
              (perioChange)="onPerioChange($event)"
              (jawMeasurementsChange)="onJawMeasurementsChange($event)"
              (moveToNextTooth)="onMoveToNextTooth()"
              (moveToPreviousTooth)="onMoveToPreviousTooth()"
              (switchToLingual)="onSwitchToLingual()"
              (switchToFacial)="onSwitchToFacial()"
              (switchToOppositeJawLingual)="onSwitchToOppositeJawLingual($event)"
              (toggleCheatSheet)="onCheatSheetToggle()"
              [isVoiceActive]="voiceStatus() === 'running'"
            >
            </ffd-perio-active-tooth-form>
          }
        }
        <div class="relative flex min-w-0 flex-1 justify-start overflow-visible pt-3" @jawSlide>
          @if (!isLastTooth() && !isReviewActive) {
            <div class="overflow-hidden">
              @if (currentPerioExamTeeth(); as perioExamTeeth) {
                @for (nextTooth of nextPerioExamTooth() ? [nextPerioExamTooth()] : []; track nextTooth!.jaw + '-' + currentSide()) {
                  <lib-perio-jaw
                    [teeth]="perioExamTeeth"
                    [selectedTooth]="nextTooth"
                    [missingTeeth]="allMissingTeethPositions()"
                    [activeSide]="currentSide()"
                    [activeJaw]="nextTooth?.jaw ?? 'upper'"
                    [showRulerLabels]="false"
                    [showSideLabels]="true"
                    [isLastTooth]="false"
                    [@jawTransitionExit]="jawAnimationPhase() === 'exit' ? jawAnimationDirection() : null"
                    [@jawTransitionEnter]="jawAnimationPhase() === 'enter' ? jawAnimationDirection() : null"
                  />
                }
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
